type Props = {
    children: any,
    area: string,
    style: object | null,
    extraClass: any
}

const AreaContainer = ({children,area,style, extraClass}: Props) => {

    return <div id={area} style={{...style, gridArea: area}} className={extraClass}>
                {children}
            </div>
};

export default AreaContainer;